<template>
  <div>
    <b-form-group v-if="allowCreate || (internalValue && internalValue.length > 0)" :label="$t('Webportal.Comments')"
      label-size="sm">
      <comment v-if="allowCreate" :templates="templates" :templateSelectionVisible="templateSelectionVisible" :templateSelectionDisabled="templateSelectionDisabled" :onSend="sendComment" />
    </b-form-group>

    <b-form-group v-for="comment of internalValue" :key="comment.SurveyRevisionCommentId">
      <comment :value="comment" :allow-edit="allowEdit" :allow-delete="allowDelete" :show-modified-hint="allowEdit" :templates="templates" :templateSelectionVisible="templateSelectionVisible" :templateSelectionDisabled="templateSelectionDisabled" :onSend="sendComment">
      </comment>
    </b-form-group>
  </div>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import ActionService from "@/services/ActionService";
import Comment from "./Comment.vue";

export default {
  name: "SurveyRevisionComments",

  mixins: [AppConfig],

  components: { Comment },

  props: {
    surveyRevisionId: { type: Number, default: null },
    surveyRevisionEntryId: { type: Number, default: null },
    value: { type: Array, default: null },
    allowCreate: { type: Boolean, default: false },
    allowEdit: { type: Boolean, default: false },
    allowDelete: { type: Boolean, default: false },
    templates: { type: Array, default: null },
    templateSelectionVisible: { default: false },
    templateSelectionDisabled: { default: false },
  },

  data() {
    return {
      newCommentText: null,
      internalValue: this.value,

      isBusy: false,
    };
  },

  watch: {
    internalValue(newVal, oldVal) {
      this.$emit("input", newVal);
    },

    isBusy(newVal, oldVal) {
      this.$emit("is-busy-changed", newVal);
    },
  },

  methods: {
    async sendComment(comment, newCommentText, isDeleted) {
      this.isBusy = true;

      const isNewComment = comment == null;

      const commentToSubmit = {
        SurveyRevisionCommentId: comment?.SurveyRevisionCommentId,
        SurveyRevisionId: this.surveyRevisionId,
        SurveyRevisionEntryId: this.surveyRevisionEntryId,
        Comment: newCommentText ?? undefined,
        IsDeleted: isDeleted ?? undefined
      };

      try {
        let response = await ActionService.createOrUpdateSurveyRevisionComment(
          this.surveyRevisionId,
          commentToSubmit
        )

        if (!response.data) return Promise.reject();

        if (isNewComment)
          if (this.internalValue)
            this.internalValue.unshift(response.data);
          else
            this.internalValue = [response.data];
        else
          Object.assign(comment, response.data);

      } catch (error) {
        console.error(error);

        this.$bvToast.toast(
          this.$t("Webportal.SaveFailed.Text", {
            entity: this.$t("Webportal.Actions.SurveyRevisionComment"),
          }),
          {
            autoHideDelay: 5000,
            variant: "danger",
            noCloseButton: true,
          }
        );

        throw error;
      }
      finally {
        this.isBusy = false;
      }
    },
  },
};
</script>
